module.exports = __webpack_public_path__ + "static/img/gggggg_12.fa7e7a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_12.png
// module id = iWN0
// module chunks = 1